import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

type ServiceWorkerState = {
  isServiceWorkerAvailable: boolean
  isNewAppVersionAvailable: boolean
}

const initialState: ServiceWorkerState = {
  isServiceWorkerAvailable: false,
  isNewAppVersionAvailable: false,
}

export const serviceWorkerSlice = createSlice({
  name: 'serviceWorker',
  initialState,
  reducers: {
    setIsServiceWorkerAvailable: (state, action: PayloadAction<boolean>) => {
      state.isServiceWorkerAvailable = action.payload
    },
    setIsNewVersionUpdateAvailable: (state, action: PayloadAction<boolean>) => {
      state.isNewAppVersionAvailable = action.payload
    },
  }
})

export const {
  setIsServiceWorkerAvailable,
  setIsNewVersionUpdateAvailable,
} = serviceWorkerSlice.actions

export const getIsServiceWorkerAvailableSelector = (state: RootState) =>
  state.serviceWorker.isServiceWorkerAvailable

export const getIsNewAppVersionAvailableSelector = (state: RootState) =>
  state.serviceWorker.isNewAppVersionAvailable

export default serviceWorkerSlice.reducer
